import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { api } from '.';
import { SortOrderEnum } from '../shared/generated';
export var apiGetOrganizationInvitations = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(organizationId) {
    var res, _err$response$data$de, _err$response, _err$response$data, _err$response$data$de2, _err$response$data$de3, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (organizationId) {
              _context.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            _context.next = 5;
            return api.get("/organization_invitations", {
              params: {
                limit: 100,
                offset: 0,
                organization_id: organizationId,
                sort_column: 'created_at',
                sort_order: SortOrderEnum.DESC
              }
            });

          case 5:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            message = (_err$response$data$de = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data.detail) === null || _err$response$data$de2 === void 0 ? void 0 : (_err$response$data$de3 = _err$response$data$de2[0]) === null || _err$response$data$de3 === void 0 ? void 0 : _err$response$data$de3.msg) !== null && _err$response$data$de !== void 0 ? _err$response$data$de : _context.t0;
            console.error("Failed to fetch organization invitations: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 9]]);
  }));

  return function apiGetOrganizationInvitations(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiInviteOrganizationMember = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
    var res, _err$response$data$de4, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (params.organization_id) {
              _context2.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(params.organization_id));

          case 3:
            _context2.next = 5;
            return api.post("/organization_invitations", params);

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data.data.organization_invitation]);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            message = (_err$response$data$de4 = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg) !== null && _err$response$data$de4 !== void 0 ? _err$response$data$de4 : _context2.t0;
            console.error("Failed to create organization invitation: ".concat(message));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function apiInviteOrganizationMember(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiGetOrganizationInvitation = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(invitationId, token) {
    var res, _err$response$data$de5, _err$response3, _err$response3$data, _err$response3$data$d, _err$response3$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (invitationId) {
              _context3.next = 3;
              break;
            }

            throw new Error("Invalid invitation id: ".concat(invitationId));

          case 3:
            _context3.next = 5;
            return api.get("/organization_invitations/".concat(invitationId), {
              params: {
                token: token
              }
            });

          case 5:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data.data.organization_invitation]);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            message = (_err$response$data$de5 = (_err$response3 = _context3.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$d = _err$response3$data.detail) === null || _err$response3$data$d === void 0 ? void 0 : (_err$response3$data$d2 = _err$response3$data$d[0]) === null || _err$response3$data$d2 === void 0 ? void 0 : _err$response3$data$d2.msg) !== null && _err$response$data$de5 !== void 0 ? _err$response$data$de5 : _context3.t0;
            console.error("Failed to fetch organization invitation: ".concat(message));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 9]]);
  }));

  return function apiGetOrganizationInvitation(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiUpdateOrganizationInvitation = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(invitationId, token, payload) {
    var res, _err$response$data$de6, _err$response4, _err$response4$data, _err$response4$data$d, _err$response4$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (invitationId) {
              _context4.next = 3;
              break;
            }

            throw new Error("Invalid invitation id: ".concat(invitationId));

          case 3:
            _context4.next = 5;
            return api.patch("/organization_invitations/".concat(invitationId), payload, {
              params: {
                token: token
              }
            });

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data.data.organization_invitation]);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            message = (_err$response$data$de6 = (_err$response4 = _context4.t0.response) === null || _err$response4 === void 0 ? void 0 : (_err$response4$data = _err$response4.data) === null || _err$response4$data === void 0 ? void 0 : (_err$response4$data$d = _err$response4$data.detail) === null || _err$response4$data$d === void 0 ? void 0 : (_err$response4$data$d2 = _err$response4$data$d[0]) === null || _err$response4$data$d2 === void 0 ? void 0 : _err$response4$data$d2.msg) !== null && _err$response$data$de6 !== void 0 ? _err$response$data$de6 : _context4.t0;
            console.error("Failed to update organization invitation: ".concat(message));
            return _context4.abrupt("return", [null, _context4.t0]);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 9]]);
  }));

  return function apiUpdateOrganizationInvitation(_x5, _x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiDeleteOrganizationInvitation = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(invitationId) {
    var res, _err$response$data$de7, _err$response5, _err$response5$data, _err$response5$data$d, _err$response5$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;

            if (invitationId) {
              _context5.next = 3;
              break;
            }

            throw new Error("Invalid invitation id: ".concat(invitationId));

          case 3:
            _context5.next = 5;
            return api["delete"]("/organization_invitations/".concat(invitationId));

          case 5:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data.data.organization_invitation]);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);
            message = (_err$response$data$de7 = (_err$response5 = _context5.t0.response) === null || _err$response5 === void 0 ? void 0 : (_err$response5$data = _err$response5.data) === null || _err$response5$data === void 0 ? void 0 : (_err$response5$data$d = _err$response5$data.detail) === null || _err$response5$data$d === void 0 ? void 0 : (_err$response5$data$d2 = _err$response5$data$d[0]) === null || _err$response5$data$d2 === void 0 ? void 0 : _err$response5$data$d2.msg) !== null && _err$response$data$de7 !== void 0 ? _err$response$data$de7 : _context5.t0;
            console.error("Failed to delete organization invitation: ".concat(message));
            return _context5.abrupt("return", [null, _context5.t0]);

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 9]]);
  }));

  return function apiDeleteOrganizationInvitation(_x8) {
    return _ref5.apply(this, arguments);
  };
}();